import Light from "../../pages/snail/wordHunt/light/index.vue";

const base = "wordHunt";

const routes = [
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Light
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/snail/wordHunt.js